<template>
  <v-card class="item" color="transparent" flat tile>
    <div class="position-relative item-shape">
      <img
        @error="onError"
        class="d-block mx-auto item-img"
        :src="files + img"
        :alt="title"
      />
    </div>

    <div
      class="
        white--text
        text-body-2 text-sm-body-1 text-md-subtitle-1 text-center
        font-weight-bold
        mt-5 mt-md-6
      "
    >
      {{ title }}
    </div>
  </v-card>
</template>

<script>
import DefaultImg from "../../assets/img/default-img.png";

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    img: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  methods: {
    onError(e) {
      e.target.src = DefaultImg;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-shape {
    &:after {
      background-image: url(../../assets/img/service-shape.png);
      background-repeat: no-repeat;
      background-size: contain;
      bottom: 0;
      content: "";
      left: 0;
      pointer-events: none;
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  &-img {
    aspect-ratio: 1;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    padding: 2px;
    width: 100%;
  }
}
</style>
